import moment from 'moment';
import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  context() {
    return {
      startDate: moment(this.model.get('start_date')).format('YYYY-MM-DD'),
      endDate: moment(this.model.get('end_date')).format('YYYY-MM-DD'),
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/list/item/headings/date_range/index.js